package com.example.mystybag.login.model

data class MerchantRegistrationCheckInboxUIState(
    val email: String = "",
    val verificationCode: String = "",
    val isLoading: Boolean = false
)

